import gql from 'graphql-tag';

export const GET_MERCHANT = gql`
  query GetMerchantsList($params: MerchantSearchInput, $package: String!) {
    merchantList(params: $params) {
      result {
        merchantId
        merchantName
        logo
        brandAssets(package: $package) {
          image {
            icon {
              path
            }
          }
        }
      }
    }
  }
`;
